import { makeHook, makeDecorator } from '@redux-syringe/injectors-react';
import { storeInterface } from '@redux-syringe/reducers';

var useReducers = makeHook(storeInterface);
var withReducers = makeDecorator(storeInterface, useReducers);

export { useReducers, withReducers };
